import _ from 'underscore';

/**
 * Change underscore template syntax as it clashed with
 * rail's template. This setting need to be done before
 * any underscore template is used.
 */
export default () => {
  $(() => {
    _.templateSettings = {
      interpolate: /\{\{=(.+?)\}\}/g,
      evaluate: /\{\{(.+?)\}\}/g,
    };
  });
};
